import { Card, CardContent, CardHeader, CircularProgress, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Tooltip, Typography } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import logger from 'src/utils/logger';
// import { text } from "../../languages/index"
import axios from "src/utils/axios";
import { getUser, openBlob,safeRequestParam } from 'src/utils/Common';

const useStyles = makeStyles(() => ({
  root: {},
  contentBulten: {
    minHeight: 430,
  },
}));


function GenericBulten({ className, param }) {

  const classes = useStyles();
  const [GenericBultenData, setGenericBultenData] = useState([]);
  const SessionUser = getUser();
  const GenericBirimKodu = SessionUser.ServiceShopId;
  const GenericTeknisyenKodu = SessionUser.TechnicianId;
  const [Loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      axios.get('/GetArtemisBulten/' + GenericBirimKodu + '/' + GenericTeknisyenKodu + '/' + (safeRequestParam(param) || 'a'))
        .then((response) => {
          if (mounted) {
            const Deger = response.data === "" ? [] : response.data;
            setGenericBultenData(Deger);
            setLoading(false);
          }
        }).catch(error => {
          setLoading(false);
          logger.error("Hata detayı:", error.message);
        });
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, [GenericBirimKodu, GenericTeknisyenKodu, param]);

  const GenericBultenAc = (logData) => {
     setLoading(true);

    const dataBultenAc = {
      BIRIM_KODU: SessionUser.ServiceShopId.toString(),
      SICIL_NO: SessionUser.UserId,
      FilePtr: logData.FP,
    };
    const configGeneric = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/FileImportExport/ArtemisBulten', dataBultenAc, configGeneric)
      .then(response => {
        openBlob(response.data, logData.BT + '_' + logData.AY + '_' + logData.BN);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
        logger.error("Hata detayı:", error.message);
      });
  };

  const user = getUser();
  let user_types = user.TechnicianType.split(",");
  let klima_teknisyeni = false;
  user_types && user_types.forEach(u => {
    if (parseInt(u) === 26) {
      klima_teknisyeni = true;
    }
  });
  if (klima_teknisyeni) {
    return <Card>
      <CardHeader title="Yetki Kontrolü" />
      <Divider />
      <CardContent className={classes.contentBulten}>
        Yetkiniz bulunmadığı için sayfa görüntülenemiyor!..
      </CardContent>
    </Card>;
  }

  return (
    <div>
      {window.navigator.onLine ?
        <Card className={clsx(classes.root, className)}>
          <Divider />
          <CardContent className={classes.contentBulten}>
            <div className={classes.inner}>
              {Loading ?
                <CircularProgress
                  status={'loading'}
                  style={{ marginLeft: '50%' }}
                />
                :
                GenericBultenData.map(Genericlog => (
                  <div key={Genericlog.BN}>
                    <List className={classes.root}>
                      <ListItem alignItems="flex-start">
                        <ListItemAvatar>
                          <div>
                            <Typography
                              component="span"
                              variant="h3"
                              className={classes.inline}
                              color="textPrimary">{Genericlog.GUN}</Typography>
                            <br />
                            <Typography
                              component="span"
                              variant="subtitle1"
                              className={classes.inline}
                              color="textPrimary">{Genericlog.AY}
                            </Typography>
                            <br />
                            <Typography
                              component="span"
                              variant="subtitle1"
                              className={classes.inline}
                              color="textPrimary">{Genericlog.YIL}
                            </Typography>
                            <br />
                          </div>
                        </ListItemAvatar>
                        <ListItemText
                          primary={Genericlog.BT}
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                className={classes.inline}
                                color="textPrimary"
                              >
                                {Genericlog.A}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                        <ListItemSecondaryAction>
                          <Tooltip title="Bülten Göster">
                            <IconButton
                              color="primary"
                              edge="end"
                              onClick={() => GenericBultenAc(Genericlog)}
                              size="small">
                              <CloudDownloadIcon />
                            </IconButton>
                          </Tooltip>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </List>
                  </div>
                ))}
            </div>
          </CardContent>
        </Card>
        :
        <Card className={clsx(classes.root, className)}>
          <CardHeader title="Ürüne Ait Bültenler" />
          <CardContent className={classes.contentBulten}>
            Offline oldugunuz için görüntüme yapılamıyor lütfen online moda geçtikten sonra tekrar deneyiniz!...
        </CardContent>
        </Card>
      }
    </div>
  );
}

GenericBulten.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({ tasks: state.tasks1 })
)(GenericBulten);

